export default __webpack_public_path__ + "static/media/dbArte.e350626d.png";